export default __webpack_public_path__ + "static/ods-23c2d50507585d05f87634a2669ba219.png";